// extracted by mini-css-extract-plugin
export default {"navLinks":"NavBar_navLinks__Bdh5A","active":"NavBar_active__9oW9-"};